import axios from "axios";

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    allNotifications: (state) => state.list,
    // Getter baru untuk menyaring notifikasi yang belum dibaca
    unreadNotifications: (state) => state.list.filter((n) => !n.is_read),
    // PERBAIKAN: Gunakan 'is_read' agar konsisten dengan komponen dan database
    unreadNotificationCount: (state) => state.list.filter((n) => !n.is_read).length,
  },

  mutations: {
    SET_NOTIFICATIONS(state, notifications) {
      state.list = notifications;
    },

    ADD_NOTIFICATION(state, notif) {
      // Normalisasi data dari WebSocket (alertmessage) ke format UI (message)
      const normalizedNotif = {
        id: notif.alertid || notif.id,
        message: notif.message || notif.alertmessage || 'New Notification',
        timestamp: notif.alerttime || notif.timestamp || new Date(),
        is_read: false,
        ...notif
      };
      state.list.unshift(normalizedNotif);
    },

    MARK_AS_READ(state, id) {
      const notif = state.list.find((n) => n.id === id);
      if (notif) notif.is_read = true; // PERBAIKAN: Ubah properti 'read' menjadi 'is_read'
    },
  },

  actions: {
    async fetchNotifications({ commit }) {
      try {
        const res = await axios.get('/api/notifications');
        // PERBAIKAN: Ambil array 'notifications' dari respons, bukan seluruh objek.
        // Pastikan res.data.notifications adalah array, jika tidak, berikan array kosong.
        const notifications = Array.isArray(res.data.notifications) ? res.data.notifications : [];
        commit("SET_NOTIFICATIONS", notifications);
      } catch (e) {
        console.error("Error fetching notifications:", e);
      }
    },

    addNotification({ commit }, notif) {
      commit("ADD_NOTIFICATION", notif);
    },

    async markAsRead({ commit }, id) {
      console.log(`[VUEX ACTION] Attempting to mark notification as read. ID: ${id}`);
      try {
        await axios.patch(`/api/notifications/${id}/read`);
        commit("MARK_AS_READ", id);
      } catch (e) {
        console.error("Error marking notification as read", e);
      }
    },
  },
};
